import {
	FacebookIcon,
	LinkedinIcon,
	RedditIcon,
	TelegramIcon,
	TwitterXIcon,
} from '../common/Icons';
import type { ShareOptions, SharePlatform, SocialLink } from './types';

const INFORA_HASHTAG = '#Infora';
const INFORA_TITLE = 'Infora';
const SHARE_URL_TEMPLATES = {
	facebook: (options: ShareOptions) => {
		const params = new URLSearchParams({
			u: options.url,
			quote: options.description || '',
		});
		return `https://www.facebook.com/sharer/sharer.php?${params}`;
	},

	twitter: (options: ShareOptions) => {
		const params = new URLSearchParams({
			url: options.url,
			text: options.title || INFORA_TITLE,
			hashtags: options.hashtags?.join(',') || INFORA_HASHTAG,
			via: options.via || INFORA_HASHTAG,
		});
		return `https://twitter.com/intent/tweet?${params}`;
	},

	linkedin: (options: ShareOptions) => {
		const params = new URLSearchParams({
			url: options.url,
			title: options.title || INFORA_TITLE,
			summary: options.description || '',
		});
		return `https://www.linkedin.com/sharing/share-offsite/?${params}`;
	},

	telegram: (options: ShareOptions) => {
		const text = [options.title, options.url].filter(Boolean).join('\n');
		return `https://telegram.me/share/url?url=${encodeURIComponent(options.url)}&text=${encodeURIComponent(text)}`;
	},

	reddit: (options: ShareOptions) => {
		const params = new URLSearchParams({
			url: options.url,
			title: options.title || INFORA_TITLE,
		});
		return `https://www.reddit.com/submit?${params}`;
	},
} as const;

export const socialLinks: Record<string, SocialLink> = {
	facebook: {
		icon: FacebookIcon,
	},
	telegram: {
		icon: TelegramIcon,
	},
	twitter: {
		icon: TwitterXIcon,
	},
	linkedin: {
		icon: LinkedinIcon,
	},
	reddit: {
		icon: RedditIcon,
	},
};

export const getShareUrl = (
	platform: SharePlatform,
	options: ShareOptions,
): string => {
	const template = SHARE_URL_TEMPLATES[platform];
	if (!template) return '';

	return template({
		...options,
		url: options.url,
	});
};

export const openShareWindow = (url: string) => {
	window.open(url, '_blank', 'width=800,height=600');
};
